import { ExpiredOfflineObjectAsyncTimestampRemover } from 'src/app/services/immo-ip-placer-offline-changes/abstract/expired-offline-object-async-timestamp-remover';
import { ProjectToTour } from './project-to-tour';

export class ExpiredProjectToTourRemover extends ExpiredOfflineObjectAsyncTimestampRemover<
  number,
  ProjectToTour
> {}
